export const EXCLUDED_KEYS = [
  "applicant_signature",
  "applicant_id_photo",
  "applicant_signature_photo",
  "applicant_id_uploaded_file",
  "applicant_signature_uploaded_file",
  "review_stage_applicant_signature_photo",
  "john_tongue_centre",
  "john_tonge_centre",
  "transfer_business_operator_qld_coroner",
  "qld_independent_doctor_name",
  "qld_independent_doctor_address",
  "qld_coroner",
  "qld_independent_doctor_phone",
  "accompanying_documents",
  "ashes_return_type_crematorium_instructions",
];

export const EXCLUDED_SUB_KEYS = [
  "deceased_nearest_surviving _relative_instructions",
  "father_boolean",
  "mother_boolean",
  "father_parent_type",
  "mother_parent_type",
  "father_occupation_other",
  "mother_occupation_other",
];

export const SPECIAL_KEYS = {
  RELATIONSHIPS: [
    "deceased_parents",
    "deceased_child",
    "deceased_children",
    "deceased_marriages",
    "deceased_registered_relationships",
    "ea_other_executors",
    "nearest_surviving_relative",
    "burial_right",
  ],
  TABLES: ["deceased_death_not_natural_causes_causes"],
};

export const BASE_EXCLUDED_SECTIONS = [
  "Welcome",
  "Declaration",
  "Declaration Instructions",
  "Estate Administration - Next Steps",
  "Upload Signature",
  "View Documents",
  "Review",
];
